import { render, staticRenderFns } from "./SelectContactBody.vue?vue&type=template&id=0bc78ce2&scoped=true&lang=pug&"
import script from "./SelectContactBody.vue?vue&type=script&lang=js&"
export * from "./SelectContactBody.vue?vue&type=script&lang=js&"
import style0 from "./SelectContactBody.vue?vue&type=style&index=0&id=0bc78ce2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc78ce2",
  null
  
)

export default component.exports